import { nextShipDate, arrivalDate, shipsToday } from '@theme/ship-date';

/**
 * Prints the live "ships today / ships Monday" line.
 *
 * Runs entirely in the shopper's browser so the countdown is real rather than frozen at
 * page-cache time. Each instance reads its own sibling config block, so the same snippet
 * can appear on a product page and inside the box builder with different wording.
 */
const fmt = new Intl.DateTimeFormat(undefined, { weekday: 'long', month: 'short', day: 'numeric' });

const countdownTo = (cutoff, now) => {
  const ms = Math.max(0, cutoff - now);
  const hours = Math.floor(ms / 3600000);
  const minutes = Math.floor((ms % 3600000) / 60000);
  return hours > 0 ? `${hours}h ${minutes}m` : `${minutes}m`;
};

const init = (host) => {
  if (host.dataset.shipBound === 'true') return;

  // The config block is emitted immediately after the <p> by the snippet.
  const configEl =
    host.nextElementSibling?.matches?.('[data-ship-date-config]')
      ? host.nextElementSibling
      : host.parentElement?.querySelector('[data-ship-date-config]');
  if (!configEl) return;

  let config;
  try {
    config = JSON.parse(configEl.textContent);
  } catch {
    return; // Bad config: leave the line hidden rather than print nonsense.
  }

  host.dataset.shipBound = 'true';

  const holidays = (config.holidays || []).map((h) => String(h).trim()).filter(Boolean);
  const textEl = host.querySelector('[data-ship-date-text]');

  const render = () => {
    const now = new Date();
    const ship = nextShipDate(now, { holidays });
    const arrive = arrivalDate(now, { holidays });

    const cutoff = new Date(now);
    cutoff.setHours(13, 0, 0, 0);

    const line = shipsToday(now, { holidays })
      ? config.templateToday.replaceAll('[countdown]', countdownTo(cutoff, now))
      : config.templateLater.replaceAll('[ship]', fmt.format(ship));

    if (textEl) textEl.textContent = line.replaceAll('[arrival]', fmt.format(arrive));
    host.hidden = false;
  };

  render();
  setInterval(render, 60000);
};

const boot = () => {
  for (const host of document.querySelectorAll('[data-ship-date]')) init(host);
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', boot, { once: true });
} else {
  boot();
}

document.addEventListener('shopify:section:load', boot);
